import {makeStyles} from "@material-ui/core";

export const styles = theme => ({
  favouriteInstrumentsText: {
    fontSize: 12,
    fontFamily: 'Roboto-Bold',
    marginLeft: 10
  },
  favouriteInstrumentsContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  errorContainer: {
    padding: 15,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    '& > i': {
      marginBottom: 15,
      color: '#ADB6BD',
      fontSize: 20
    },

    '& > p': {
      fontFamily: 'Roboto-Regular',
      color: '#63696F',
      textAlign: 'center',
      margin: 0
    }
  },
  extraActionItem: {
    '& > button': {
      padding: '2px 8px'
    }
  },
  extraActionItemContained: {
    '& > button': {
      padding: '4px 8px'
    }
  }
})


export default makeStyles(styles);

export const switchStyles = makeStyles(() => ({
  // styles of the switch
  container: {
    width: 36,
    height: 20,
  },
  thumb: {
    height: 16,
    width: 16,
    top: 1,
    left: 1,
  },
  checked: {
    transform: 'translateX(16px) !important',
  }
}));